import React from 'react';
import Icons from '../../../../../core/modules/common/components/Icons';

export default postalOperators => postalOperators
  .filter(postalOperator =>
    postalOperator.mailProcessingCenters && postalOperator.mailProcessingCenters.length)
  .map((postalOperator) => {
    const childrenMailProcessingCenter = postalOperator.mailProcessingCenters
      .map(mailProcessingCenter =>
        ({
          value: mailProcessingCenter.code,
          label: <span>{mailProcessingCenter.code} - {mailProcessingCenter.longName ? mailProcessingCenter.longName : ''} {mailProcessingCenter.inactiveDaysInSelectedPeriod ? <Icons.Custom className="warning-icon" name="exclamation-triangle" /> : ''}</span>,
        }));
    return {
      value: postalOperator.postalOperatorCode,
      label:
      // eslint-disable-next-line no-nested-ternary
          (postalOperator.shortPostalOperatorCode ? `${postalOperator.shortPostalOperatorCode} - ` : '') + (postalOperator.longName
        ? postalOperator.longName : (postalOperator.shortName ? postalOperator.shortName : '')),
      children: childrenMailProcessingCenter,
    };
  });
